import { useEffect, useMemo } from 'react';

/**
 * Creates an object URL for a File, Blob, or MediaSource and revokes it when
 * the component unmounts or the source changes, preventing memory leaks.
 */
export const useObjectUrl = (source: Blob): string => {
  const objectUrl = useMemo(() => URL.createObjectURL(source), [source]);

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  return objectUrl;
};
